import {
	faCircleQuestion as farCircleQuestion,
	faFileContract as farFileContract,
	faGift as farGift,
	faStars as farStars,
} from "@awesome.me/kit-3777c2145e/icons/classic/regular";
import { faRight as fasRight } from "@awesome.me/kit-3777c2145e/icons/classic/solid";
import { LoanInsuranceSmallCalculator } from "@component/LoanInsurance/SmallCalculator/LoanInsuranceSmallCalculator";
import { Ad } from "@component/Widget/Ad/Ad";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { LandingAccordion } from "@landing/components/LandingAccordion";
import { LandingBottom } from "@landing/components/LandingBottom";
import { LandingHeader } from "@landing/components/LandingHeader";
import { LandingHeaderLayout } from "@landing/components/LandingHeaderLayout";
import { Button, IconBox, IconBoxGrid, IconTextBlock, LandingContainer, List, Stack, Typography } from "bm-ui-kit";
import type { ReactNode } from "react";
import React from "react";
import { Accordion, Col, Row } from "react-bootstrap";
import "./csoportos-szemelybiztositas.scss";

/**
 * @Routing
 *
 * @title "Csoportos személybiztosítás"
 * @description "Használd ki a csoportos személybiztosítás előnyeit, és élj a kedvezményekkel. Kedvezőbb feltételek, költségek, szélesebb szolgáltatási kör és egyszerű szerződés."
 * @route "/biztositas/csoportos-szemelybiztositas/"
 */
export default class Landing extends React.PureComponent {
	public render(): ReactNode {
		return (
			<>
				<LandingHeader id="kalkulator" theme="retail">
					<LandingHeaderLayout template="small-calculator">
						<Stack
							gap={{
								xs: 4,
								lg: 5,
							}}
						>
							<div>
								<h1>
									<Typography variant="title-1" gutterBottom>
										Csoportos <br />
										személybiztosítás
									</Typography>
								</h1>
								<Typography variant="subtitle-1">
									Használd ki a csoportos személybiztosítás előnyeit, és élj a vele járó
									kedvezményekkel.
								</Typography>
							</div>
							<IconBoxGrid>
								<IconBox icon={<FontAwesomeIcon icon={farGift} />} direction={{ lg: "vertical" }}>
									Kedvezőbb feltételek és költségek
								</IconBox>
								<IconBox icon={<FontAwesomeIcon icon={farStars} />} direction={{ lg: "vertical" }}>
									Szélesebb szolgáltatási kör
								</IconBox>
								<IconBox
									icon={<FontAwesomeIcon icon={farFileContract} />}
									direction={{ lg: "vertical" }}
								>
									Egyszerű szerződéskötés
								</IconBox>
							</IconBoxGrid>
							<div className="d-none d-lg-block mt-2">
								<IconTextBlock
									icon={<FontAwesomeIcon icon={farCircleQuestion} />}
									title="Mi az a csoportos személybiztosítás?"
								>
									Egy olyan biztosítás, melyet a Biztosító egy adott csoporttal köt meg, gyakorlatilag
									egyetlen szerződéssel több személy is biztosított lehet. Ezzel elérhetővé válhatnak
									olyan kedvezmények, melyeket önállóan nem biztos, hogy meg tudnál szerezni.
								</IconTextBlock>
							</div>
						</Stack>
						<LoanInsuranceSmallCalculator />
					</LandingHeaderLayout>
				</LandingHeader>
				<LandingContainer bgClassName="bg-light" size="lg">
					<Row>
						<Col lg="3" className="pb-3 pt-3 pb-md-0 border-right border-primary">
							<h2 className="h4 text-center pb-2">
								A Bankmonitornál elérhető csoportos személybiztosítások
							</h2>
							<List itemStyle="square" variant="secondary" className="mb-4">
								<List.Item>
									<h3 className="h4 mb-0">Bankmonitor Biztonság</h3>
									<p className="mb-0">Csoportos Személybiztosítás</p>
									<Button
										variant="secondary"
										size="sm"
										outlined
										className="my-2 d-inline-block"
										icon={<FontAwesomeIcon icon={fasRight} />}
										href="/vedelem/bankmonitor-biztonsag/?link_type=landing-button"
									>
										Tovább a termékhez
									</Button>
								</List.Item>
								<List.Item>
									<h3 className="h4 mb-0">SIGNAL IDUNA</h3>
									<p>HITELES VÉDELEM Csoportos Élet-, baleset- és egészségbiztosítás</p>
								</List.Item>
							</List>
						</Col>
						<Col lg="9">
							<h2 className="h1 mb-lg-4 mb-md-3 mb-2">Hogyan lehet csoportos személybiztosításom?</h2>
							<p>
								<strong>A csoportos személybiztosításnak alapvetően három szereplője van.</strong>
							</p>
							<List itemStyle="tick" variant="secondary">
								<List.Item>A Biztosító, aki magát a védelmet, biztosítást nyújtja.</List.Item>
								<List.Item>A szerződő fél, akivel a Biztosító szerződést köt.</List.Item>
								<List.Item>
									A biztosított, akire a védelem kiterjed. A biztosított a csoporthoz csatlakozást
									követően élvezheti a biztosítási védelmet.
								</List.Item>
							</List>
							<p>
								Gyakorlatilag csatlakoznod kell a csoporthoz és már élvezheted is a biztosítás előnyeit.
								Ez természetesen nem minden esetben olyan egyszerű, hiszen vannak olyan csoportok,
								melyeknél a csatlakozáshoz bizonyos kritériumoknak teljesülnie kell.
							</p>
							<p>
								Például bankok hoznak létre ilyen csoportot a számlával, hitellel rendelkező
								ügyfeleiknek, és mint a biztosítás szerződője, ők nyújtanak ügyfeleiknek a csatlakozást
								követően valamilyen típusú védelmet. Jelen esetben tehát az adott bankkal kell
								szerződésben állnod.
							</p>
							<p>
								Van olyan eset, amikor a munkáltató hoz létre egy ilyen csoportot, köt biztosítást a
								náluk dolgozó alkalmazottakra. Ezáltal a fizetés mellett megjelenhet ez az extra
								védelem, szolgáltatás mint egy kiegészítő juttatásként. Ebben az esetben feltétel, hogy
								az adott cégnél dolgozz.
							</p>
							<p>
								De akár Egyesületek is köthetnek biztosítást, ebben az esetben a tagokra terjed ki a
								védelem.
							</p>
						</Col>
					</Row>
				</LandingContainer>
				<LandingContainer size="lg">
					<Row className="justify-content-center">
						<Col lg={10}>
							<h2 className="h1 mb-lg-4 mb-md-3 mb-2 text-center">
								Általános tudnivalók a hitelfedezeti biztosításról
							</h2>
							{this.renderFaq()}
							<Ad
								name="300x250 MOBIL TOP2"
								code="5967599"
								width="300"
								height="250"
								type="non-desktop"
								priority={46}
							/>
						</Col>
					</Row>
				</LandingContainer>
				<LandingBottom tags="biztositas" />
			</>
		);
	}

	private renderFaq(): ReactNode {
		return (
			<>
				<Accordion>
					<LandingAccordion title="Mi az előnye?">
						<p>
							Egy csoportos biztosítás olcsóbb lehet, mint egy hasonló egyéni biztosítás. Ez érthető is,
							hiszen a tagok gyakorlatilag érvényesíteni tudják a csoport méretéből adódó kedvezményeket.{" "}
							<br />
							Sok esetben még a szolgáltatások köre is szélesebb lehet egy csoportos biztosításnál.
							<br />
							Gyakorlatilag a szerződést a biztosító és az adott csoport köti meg, az egyes magánszemélyek
							a csoporthoz csatlakozással érhetik el a biztosítási védelmet. Vagyis maga a folyamat is
							jóval egyszerűbb.
						</p>
					</LandingAccordion>
				</Accordion>
				<Accordion>
					<LandingAccordion title="Mi a hátránya?">
						<p>
							A csoport tagjai jellemzően ugyanazt a biztosítási védelmet kapják meg. Vagyis a szerződést
							nem – vagy csak minimálisan – lehet az egyes személyek egyedi igényeihez igazítani. <br /> A
							csoportból kilépés maga után vonja a biztosítási jogviszony megszűnését is. (Például a
							munkáltatód által kötött csoportos biztosítás csak addig érvényes rád, amíg az adott
							munkahelyen dolgozol.)
						</p>
					</LandingAccordion>
				</Accordion>
				<Accordion>
					<LandingAccordion title="Milyen fajtái lehetnek?">
						<p>
							Több különféle biztosítási védelem is elérhető a csoportos személybiztosítások között.
							Ilyenek például:
						</p>
						<ul>
							<li>Hitelfedezeti életbiztosítás</li>
							<li>Törlesztésvédelmi biztosítás</li>
							<li>Egészségbiztosítás</li>
							<li>Balesetbiztosítás</li>
						</ul>
						<p>
							Mindez attól függ, hogy a Szerződő, csoport képviselője milyen védelmet szeretne, illetve
							miben tud megállapodni a Biztosítóval a szerződéskötés során.
						</p>
					</LandingAccordion>
				</Accordion>
			</>
		);
	}
}
